module.exports = __webpack_public_path__ + "da061416028fc9a66fbc0b80d33d6e6f.eot";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/SemiboldItalic/OpenSans-SemiboldItalic.eot?v=1.1.0
// module id = 997
// module chunks = 0